import { Column } from 'primereact/column';
import { DataTable, DataTableRowClickEvent } from 'primereact/datatable';
import React, { useState } from 'react';
import TopRequestorDatatable from '../TopRequestorDataTable';
import { ProgressSpinner } from 'primereact/progressspinner';
import { convertedHoursMinutes } from 'src/utils/function';

const RequestorList = ({ modalOpenTopResponsive, requestorListData, isLoading }: any) => {
    const [jobListData, setJobListData] = useState<any>([]);

    const GetName = (row: any) => (
        <div className="text-gray100 text-xs font-medium flex">
            <p className="mr-6 max-md:mr-3">{row.requestorName}</p>
        </div>
    );

    const GetJobs = (row: any) => (
        <div className="text-gray100 text-xs font-medium flex">
            <p className="mr-6 max-md:mr-3">{row.totalJobsAssigned} job</p>
        </div>
    );

    const GetHours = (row: any) => (
        <div className="text-gray100 text-xs font-medium flex">
            <p className="mr-6 max-md:mr-3">{convertedHoursMinutes(row.totalWorkingHours, ':')}</p>
        </div>
    );

    const [expandedRows, setExpandedRows] = useState<{ [key: string]: boolean }>({});

    const onRowClick = (e: DataTableRowClickEvent) => {
        const selectedId = e.data.requestorID.toString();
        const isAlreadyExpanded = expandedRows[selectedId];

        if (isAlreadyExpanded) {
            setExpandedRows({});
            setJobListData([]);
        } else {
            const filteredJobs = requestorListData.jobList.filter((job: any) => Number(job.requestorId) === Number(selectedId));
            const processedJobs = filteredJobs.map((element: any) => {
                const parsedEmployees = typeof element.employeeList === 'string' ? JSON.parse(element.employeeList) : element.employeeList;
                return { ...element, employeeList: parsedEmployees };
            });
            setJobListData(processedJobs);
            setExpandedRows({ [selectedId]: true });
        }
    };

    const rowExpansionTemplate = (data: any) => (
        <div className=" px-4 max-h-[400px] overflow-y-auto">
            <TopRequestorDatatable jobListData={jobListData} modalOpenTopResponsive={''} />
        </div>
    );

    return (
        <div className="min-w-[1270px] max-lg:max-w-96">
            <div className="text-center text-zinc-800 text-lg font-medium font-['Satoshi Variable']">
                <h1>{modalOpenTopResponsive}</h1>
            </div>
            <div className={`${modalOpenTopResponsive === 'Requestor List' ? 'h-[calc(100vh-150px)]' : ''} scrollbar-hide overflow-y-auto`}>
                {isLoading ? (
                    <div className="card w-full h-full flex justify-content-center items-center ">
                        <ProgressSpinner />
                    </div>
                ) : (
                    <DataTable
                        value={requestorListData.requestorList}
                        dataKey="requestorID"
                        expandedRows={expandedRows}
                        expandedRowIcon="pi pi-chevron-down"
                        rowExpansionTemplate={rowExpansionTemplate}
                        onRowClick={onRowClick}
                        tableStyle={{ minWidth: '50rem', maxWidth: '100%' }}
                        emptyMessage="No Record Found"
                        rowClassName={(data: any) =>
                            expandedRows && expandedRows[data.requestorID] ? '!bg-[#f2f4f7]' : 'hover:cursor-pointer hover:!bg-[#f2f4f7] transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]'
                        }
                    >
                        <Column field="requestorName" header="Requestor Name" body={GetName} />
                        <Column field="totalJobsAssigned" header="Total Jobs" body={GetJobs} />
                        <Column field="totalWorkingHours" header="Total Hours" body={GetHours} />
                    </DataTable>
                )}
            </div>
        </div>
    );
};

export default RequestorList;
